import { RouteConfig } from 'vue-router';

const platform: RouteConfig = {
  path: '/platform',
  component: () => import('../views/platform/platform.vue'),
  meta: {
    title: '数据开发中心'
  },
  children: [
    {
      path: '/platform/permision',
      meta: {
        title: '系统授权管理'
      },
      component: () => import('../views/platform/pages/permision/permision.vue'),
      children: [
        {
          path: '/platform/permision/detail',
          meta: {
            title: '角色详情'
          },
          component: () => import('../views/platform/pages/permision/permision-detail.vue')
        }
      ]
    },
    {
      path: '/platform/syslog',
      meta: {
        title: '操作日志管理'
      },
      component: () => import('../views/platform/pages/syslog/syslog.vue')
    }
  ]
};

export default platform;
